import { Column } from 'further-ui/components/Layout';
import Table, { type Column as TableColumn } from 'further-ui/components/Table';
import { ActionRefLabels } from 'further-ui/labels';
import { numberToCurrencyString } from 'further-ui/utils';
import { CommitmentData } from '../../types';

type Props = Pick<
  CommitmentData,
  'currencySettings' | 'capitalBalanceAndReconciledPayments'
>;

const CapitalBalanceAndReconciledPayments: React.FC<Props> = ({
  currencySettings,
  capitalBalanceAndReconciledPayments,
}) => {
  const { currencyLcy } = currencySettings;
  const { data, totals } = capitalBalanceAndReconciledPayments;

  const columns: Array<TableColumn<(typeof data)[number]>> = [
    {
      label: 'Date',
      key: 'date',
      width: 140,
      render: ({ date }) => date.toReadable(),
      footer: 'Total',
    },
    {
      label: 'Type',
      key: 'type',
      width: 200,
      render: ({ type }) => ActionRefLabels[type],
    },
    {
      label: 'Amount',
      key: 'valueLcy',
      width: 170,
      render: ({ valueLcy }) =>
        numberToCurrencyString(valueLcy, { currency: currencyLcy }),
      footer: numberToCurrencyString(totals.valueLcy, {
        currency: currencyLcy,
      }),
    },
    {
      label: 'Running balance',
      key: 'runningBalanceLcy',
      width: 170,
      render: ({ runningBalanceLcy }) =>
        numberToCurrencyString(runningBalanceLcy, { currency: currencyLcy }),
    },
  ];

  return (
    <Column>
      <Table
        scrollable
        emptyMessage="No entries"
        columns={columns}
        rows={data}
      />
    </Column>
  );
};

export default CapitalBalanceAndReconciledPayments;
